module.exports = false;



/*****************
 ** WEBPACK FOOTER
 ** /Users/endriu/Work/adoratorio/temp/ahs-site/ahs/~/core-js/modules/_library.js
 ** module id = 22
 ** module chunks = 0
 **/